import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
    imprestApplications,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { LeaveApplicationsColumns, imprestApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import LeaveApplicationForm from "./form";
import ImprestApplicationForm from "../ImprestByUser/form";
import ImprestDocumentsDrawer from "../ImprestByUser/ImprestDocumentsDrawer";

const base_url = HRService.uri;

function ImprestPendingApprovalsTable() {
  const [docsDrawerOpen, setDocsDrawerOpen] = useState(false);
  const [selectedRecordForDocs, setSelectedRecordForDocs] = useState(null);

  const actions = {
 // entity: " Imprest Approvals",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

 // ---------- APPROVE ----------
  APPROVEIMPREST: {
    key: "APPROVEIMPREST",
    button_name: "Approve",
    Show_Button: (row) => row.statusId === 1,   // only when pending
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },

  // ---------- REJECT ----------
  REJECTIMPREST: {
    key: "REJECTIMPREST",
    button_name: "Reject",
    Show_Button: (row) => row.statusId === 1,   // only when pending
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
 ViewImprestLines: {
      key: "ViewImprestLines",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },  
   modelName: "allImprestApplicationPendingApproval", 
         dataObject: {
             // *** UPDATE: The input field must match the GraphQL variable (feeNotesLines) ***
             inputFields: {
                approverUserId: null,
            },
             
             // *** UPDATE: inputObjectName matches the GraphQL operation name (without 'query') ***
             inputObjectName: "allImprestApplicationPendingApproval", 
             
             // *** UPDATE: inputSubObjectName is the array of results returned by the operation ***
             // Assuming the results array is directly returned by the operation.
             // If the API nests the array under another field, change this accordingly.
             inputSubObjectName: "parameters", // Often the same as inputObjectName if the array is directly returned.
             
             returnFields: [
              "id",
                "title",
                "description",
                "amount",
                "status",
                "statusText",
                "approverCount",
                "declinerCount",
                "declinedReason",
                "caseRelated",
                "caseId",
                "caseTitle",
                "isPettyCash",
                "isDisbursed",
                "isActive",
                "createdDate",
                "updatedDate",
                "approvedDate",
                "disbursedDate",
                "currencyId",
                "currencyCode",
                "currencyName",
                "snapshotExchangeRate",
                "currentExchangeRate",
                "amountInBaseCurrency",
                "accountId",
                "accountName",
                "disbursementAccountType",
                "disbursementBankAccountId",
                "disbursementBankAccountName",
                "paymentReference",
                "companyId",
                "company",
                "employeeId",
                "userId",
                "applicantUsername",
                "applicantFullName",
                "regionId",
                "region",
                "branchId",
                "branch",
                "createdByUsername",
                "updatedByUsername",
                "approvedByUsername",
                "disbursedByUsername",
                "approverComments"
             ],
         },

    ViewDocuments: {
      key: "ViewDocuments",
      button_name: "View Documents",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row) => {
        setSelectedRecordForDocs(row);
        setDocsDrawerOpen(true);
      },
    },
  actionName: " Imprest Requisition ",
  showStatus: true,
};

  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Imprest Pending Approvals"
          subtitle="View all imprest Application Pending approvals, approve or decline"
          columns={imprestApplicationsColumns}
          FormComponent={ImprestApplicationForm}
          //query={imprestApplications}
          actions={actions}
          base_url={base_url}
        />
        <ImprestDocumentsDrawer
          open={docsDrawerOpen}
          onClose={() => {
            setDocsDrawerOpen(false);
            setSelectedRecordForDocs(null);
          }}
          imprestId={selectedRecordForDocs?.id}
        />
      </>
    </Box>
  );
}

export default ImprestPendingApprovalsTable;
